import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, ZoomIn } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";
import { gallery } from "../data/business";

export default function Portfolio() {
    const [active, setActive] = useState(null);

    return (
        <section
            id="resultados"
            data-testid="portfolio-section"
            className="bg-paper py-20 sm:py-28 lg:py-36"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
                <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
                    <div>
                        <Eyebrow>Portfólio</Eyebrow>
                        <Reveal delay={0.1}>
                            <h2 className="mt-5 font-display text-3xl font-medium uppercase leading-[1.1] tracking-tight text-ink sm:text-4xl lg:text-5xl">
                                Resultados reais.
                                <br />
                                <span className="italic text-accent">Em clientes reais.</span>
                            </h2>
                        </Reveal>
                    </div>
                    <Reveal delay={0.2}>
                        <p className="max-w-sm text-sm text-ink-soft">
                            Uma seleção de trabalhos realizados no Studio Danielly
                            Sousa.
                        </p>
                    </Reveal>
                </div>

                <div className="mt-14 columns-1 gap-6 sm:columns-2 lg:columns-3">
                    {gallery.map((g, i) => (
                        <Reveal
                            key={`${g.url}-${i}`}
                            delay={(i % 3) * 0.08}
                            className={`mb-6 break-inside-avoid ${i % 4 === 0 ? "sm:col-span-2 sm:w-full" : ""}`}
                        >
                            <button
                                data-testid={`gallery-item-${i + 1}`}
                                onClick={() => setActive(g)}
                                className="group relative block w-full overflow-hidden text-left"
                                aria-label={`Ampliar: ${g.title}`}
                            >
                                <div className={`w-full overflow-hidden ${g.ratio}`}>
                                    <img
                                        src={g.url}
                                        alt={g.title}
                                        loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
                                    />
                                </div>
                                <div className="absolute inset-0 flex items-end bg-gradient-to-t from-ink/70 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                                    <div className="p-5">
                                        <p className="font-mono text-[9px] uppercase tracking-[0.25em] text-accent">
                                            {g.category}
                                        </p>
                                        <p className="mt-1 font-display text-lg text-paper">
                                            {g.title}
                                        </p>
                                    </div>
                                    <ZoomIn size={18} className="absolute right-4 top-4 text-paper/80" />
                                </div>
                            </button>
                        </Reveal>
                    ))}
                </div>
            </div>

            <AnimatePresence>
                {active && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 z-[70] flex items-center justify-center bg-ink/95 p-4 sm:p-10"
                        onClick={() => setActive(null)}
                    >
                        <button
                            data-testid="lightbox-close"
                            aria-label="Fechar"
                            onClick={() => setActive(null)}
                            className="absolute right-5 top-5 flex h-11 w-11 items-center justify-center border border-paper/25 text-paper transition-colors hover:border-accent hover:text-accent"
                        >
                            <X size={20} />
                        </button>
                        <motion.figure
                            initial={{ scale: 0.94, y: 20 }}
                            animate={{ scale: 1, y: 0 }}
                            exit={{ scale: 0.96, opacity: 0 }}
                            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                            onClick={(e) => e.stopPropagation()}
                            className="max-h-full max-w-4xl"
                        >
                            <img
                                src={active.url}
                                alt={active.title}
                                className="max-h-[75vh] w-full object-contain"
                            />
                            <figcaption className="mt-4 text-center">
                                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-accent">
                                    {active.category}
                                </p>
                                <p className="mt-1 font-display text-xl text-paper">
                                    {active.title}
                                </p>
                            </figcaption>
                        </motion.figure>
                    </motion.div>
                )}
            </AnimatePresence>
        </section>
    );
}
